export const Creatives = () => {
    return <div>Creatives</div>
}
